import request from '@/utils/request'

let ApplinkApi = {

  /*APP广告列表*/
  list(data) {
    return request._post('/shop/plus.applink.Index/index', data);
},
/*添加APP广告*/
add(data) {
    return request._post('/shop/plus.applink.Index/add', data);
},
/*修改APP广告*/
edit(data) {
    return request._post('/shop/plus.applink.Index/edit', data);
},
/*删除APP广告*/
del(data) {
    return request._post('/shop/plus.applink.Index/del', data);
},
/*APP广告详情*/
detail(data) {
  return request._post('/shop/plus.applink.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.applink.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.applink.Setting/getSetting', data, errorback);
    },
}
export default ApplinkApi;



// WEBPACK FOOTER //
// ./src/api/applink.js